import { makeCompanyQueryHttp } from '../../_shared/infrastructure/company-query.http';
import type { CompaniesGateway } from './companies.gateway';

/** Admin Companies list → `GET /companies` (the backend widens it for an admin). */
export const httpCompaniesGateway: CompaniesGateway = makeCompanyQueryHttp('/companies');
